import { useMutation } from '@tanstack/react-query';
import {
    agentRole,
  UserApiService,
} from 'features/users/api/user-api.service';
const { saveagentPrivilePermissions } = UserApiService();

export const useCreatePrivilepermissionRole = () => {

  return useMutation(
    (payload: agentRole) => {
      return saveagentPrivilePermissions(payload);
    },
  );
};





